import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UrlServidor } from "../util/url-servidor";
import { Observable } from "rxjs";
import { ConciliarConta } from "../api/dto/conciliar-conta";

@Injectable({
    providedIn: 'root'
})
export class ConciliarContaService{

    constructor(private http: HttpClient) {}

    private url: string = UrlServidor.URL_BASE + 'conciliar-contas/';

    listarConciliarContasPorEmpresa(empresaId?: number): Observable<ConciliarConta[]> {
        return this.http.get<ConciliarConta[]>(this.url + 'empresa/' + empresaId);
    }

}